import { render, staticRenderFns } from "./Ipay88SuccessPageView.vue?vue&type=template&id=7e1a37df&"
import script from "./Ipay88SuccessPageView.vue?vue&type=script&lang=js&"
export * from "./Ipay88SuccessPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports